import React from 'react';
import BaseComponent from "../../../base/BaseComponent";
import {Card} from 'antd';

class MyCard extends BaseComponent {

    render() {
        return (
            <div className="MyCardContainer">
                <Card
                title={this.props.title || "标题"}
                className={this.props.className}
                headStyle={{height: 32}}
                bodyStyle={{padding: '12px 24px', height: (this.props.height - 32 - 12)}}
            >
                    {React.Children.map(this.props.children, child => child)}
                </Card>
                <style>{`
                    .MyCardContainer>.ant-card{
                        border-radius:5px
                    }
                `}</style>
            </div>
        );
    }
}

export default MyCard;